// Save Social Marketing parameter
function saveSocialUTMParams() {
    const socialMarketingParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let socialMarketingPromoUTMItems = {};

    if (sessionStorage.getItem('socialMarketingPromoUTM')) {
        socialMarketingPromoUTMItems = JSON.parse(sessionStorage.getItem('socialMarketingPromoUTM'));
    }

    socialMarketingParams.forEach((socialMarketingParam) => {
        if (urlParams.has(socialMarketingParam)) {
            socialMarketingPromoUTMItems[socialMarketingParam] = urlParams.get(socialMarketingParam);
        }
    });

    sessionStorage.setItem("socialMarketingPromoUTM", JSON.stringify(socialMarketingPromoUTMItems));
}
saveSocialUTMParams();
// Save Social Marketing parameter

// Adding Accessbility to Pagefly's Accordion elements, so that toggle status is read to screen readers
document.addEventListener("DOMContentLoaded", function () {
    function updateAriaExpanded(button) {
        const isActive = button.getAttribute("data-active") === "true";
        button.setAttribute("aria-expanded", isActive);
    }

    function initializeAccordions() {
        const accordions = document.querySelectorAll('button[data-pf-type="Accordion.Header"]');

        accordions.forEach(button => {
            updateAriaExpanded(button);
        });
    }

    // Monitor accordion state changes
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === "data-active") {
                updateAriaExpanded(mutation.target);
            }
        });
    });

    // Observe all accordions
    document.querySelectorAll('button[data-pf-type="Accordion.Header"]').forEach(button => {
        observer.observe(button, { attributes: true });
    });

    // Initialize on page load
    initializeAccordions();
});

function saveUTMSource() {
    const path = window.location.pathname
    const sources = {
        '/pages/tiktok': 'tiktok',
        '/pages/meta': 'meta'
    }

    if (path in sources) {
        const sessionStorageItem = sessionStorage.getItem("socialMarketingPromoUTM")

        if (sessionStorageItem !== null) {
            const payload = JSON.parse(sessionStorageItem)
            payload['utm_source'] = sources[path]

            sessionStorage.setItem("socialMarketingPromoUTM", JSON.stringify(payload))
        } else {
            const payload = {'utm_source': sources[path]}
            sessionStorage.setItem("socialMarketingPromoUTM", JSON.stringify(payload))
        }
    }
}

saveUTMSource()
